import { checkAvifSupport } from "@/utils/util";
import dayjs from "dayjs";

export const orderStatusName = function (status) {
  let statusName = "";
  switch (status) {
    case "Waiting delivery":
      statusName = "待发货";
      break;
    case "Awaiting Payment":
      statusName = "待付款";
      break;
    case "Canceled":
      statusName = "已取消";
      break;
    case "On delivery":
      statusName = "已发货";
      break;
    case "In operation":
      statusName = "生产中";
      break;
  }
  return statusName;
};

export const default_img = function (path, resize = true) {
  if (!path) {
    return require("@/assets/images/default.jpg");
  }
  
  if (!resize) {
    return path;
  }
  
  const avifSupported = checkAvifSupport();
  return path + (avifSupported ? "?x-oss-process=image/format,avif" : "");
};

export const default_avatar = function (path) {
  return path ? path : require("@/assets/images/default-black.jpg");
};

export const get_sex = function (type) {
  switch (Number(type)) {
    case 0:
      return "不限";
    case 1:
      return "男款";
    case 2:
      return "女款";
  }
};

export const sex_filter = function (type) {
  switch (Number(type)) {
    case 0:
      return "不限";
    case 1:
      return "男";
    case 2:
      return "女";
    case 3:
      return "儿童";
    default:
      return "-";
  }
};

export const price_format = (value) => {
  return value ? (Math.round(value * 100) / 100).toFixed(2) : 0;
};

export const duration_text = (datetime) => {
  let txt = datetime;
  let d = new Date(datetime);
  let duration = Math.ceil((Date.now() - d.getTime()) / 1000);
  if (duration < 60) {
    // 1分钟内
    txt = "刚刚";
  } else if (duration < 3600) {
    // 一小时内
    txt = Math.floor(duration / 60) + "分钟前";
  } else if (duration < 86400) {
    // 一天内
    txt = Math.floor(duration / 3600) + "小时前";
  } else if (duration < 86400 * 7) {
    // 一周内
    txt = Math.floor(duration / 86400) + "天前";
  } else {
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const day = d.getDate().toString().padStart(2, "0");
    const year = d.getFullYear();
    txt = `${year}-${month}-${day}`;
  }

  return txt;
};

/**
 * 日期格式化
 * @param {*} datetime
 * @param {*} format
 * @returns
 */
export const date_format = (datetime, format = "YYYY-MM-DD") => {
  return formatDate(datetime, format);
};

function formatDate(value, format) {
  if (!value) return "";
  const date = dayjs(value);
  return date.isValid() ? date.format(format) : "";
}

/**
 * 手机号打码
 */
export const phone_format = (phone) => {
  if (!phone) return "";
  return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
};

export const default_team_logo = function (path) {
  return path
    ? path
    : require("@/assets/images/team/icon-team-logo-default.png");
};

//>基于dayjs,根据传入时间进行时间格式化,显示x天x时x分
export const time_format = (time) => {
  // 参数校验
  if (typeof time !== "number" || time < 0) return "";

  if (time === 0) return "已过期";

  // 转换为天、小时、分钟
  const days = Math.floor(time / (24 * 60 * 60));
  const hours = Math.floor((time % (24 * 60 * 60)) / (60 * 60));
  const minutes = Math.floor((time % (60 * 60)) / 60);

  // 拼接格式化字符串
  let result = "";
  if (days > 0) result += `${days}天`;
  if (hours > 0) result += `${hours}时`;
  if (minutes > 0) result += `${minutes}分`;

  return result || "即将到期"; // 如果全部为0，显示默认文案
};

export const pay_methods_icon_logo = (type) => {
  switch (type) {
    case "wechat":
      return require("@/assets/images/icon-wechatpay-full.png");
    case "alipay":
      return require("@/assets/images/icon-alipay-full.png");
      break;
  }
};
export const pay_methods_icon = (type) => {
  switch (type) {
    case "wechat":
      return require("@/assets/images/icon_weixin@2x.png");
    case "alipay":
      return require("@/assets/images/icon_alipay@2x.png");
    case "offline":
      return require("@/assets/images/icon-pay-offline.png");
    default:
      break;
  }
};

export const pay_methods_help = (type) => {
  switch (type) {
    case "wechat":
      return require("@/assets/images/wechat-pay-help.png");
    case "alipay":
      return require("@/assets/images/alipay-pay-help.png");
    default:
      break;
  }
};

export const pay_methods_name = (type) => {
  switch (type) {
    case "wechat":
      return "微信";
    case "alipay":
      return "支付宝";
    case "offline":
      return "线下";
    case "balance":
      return "余额";
    default:
      return "";
  }
};
